import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import EditPropertyForm from "../components/EditPropertyForm";
import PropertyImageUpload from "../components/PropertyImageUpload";
import RequireRole from "../components/RequireRol";

const EditProperty = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <RequireRole
            allowedRoles={["propietario", "admin", "gestor_inmobiliario"]}
            customMessage="Solo los propietarios y administradores pueden editar propiedades."
        >
            <div className="container mx-auto px-4 py-8">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-4 text-blue-600 hover:underline"
                >
                    ← Volver
                </button>
                <EditPropertyForm />
            </div>
        </RequireRole>
    );
};

export default EditProperty; 